import DetailedView from './DetailedView';
export default DetailedView;
